import catalog from '../data/yarns.json';

export interface CatalogYarn {
  brand: string;
  line: string;
  weightId: string;
  cycWeight: number;
  fiber: string;
  fiberClass: string;
  gaugeSts: number | null;
  needleUS: string | null;
  yardage: number | null;
  grams: number | null;
  sampleColorways: string[];
}

export const YARN_CATALOG = catalog as CatalogYarn[];

/** Lightweight scored search over brand / line / fibre / colourways. */
export function searchYarns(q: string, limit = 8): CatalogYarn[] {
  const query = (q || '').trim().toLowerCase();
  if (query.length < 2) return [];
  const terms = query.split(/\s+/);
  const scored: { y: CatalogYarn; score: number }[] = [];
  for (const y of YARN_CATALOG) {
    const hay = `${y.brand} ${y.line} ${y.fiber} ${y.sampleColorways.join(' ')}`.toLowerCase();
    const label = `${y.brand} ${y.line}`.toLowerCase();
    let score = 0;
    let ok = true;
    for (const t of terms) {
      if (!hay.includes(t)) {
        ok = false;
        break;
      }
      if (label.startsWith(t)) score += 5;
      else if (label.includes(t)) score += 3;
      else score += 1;
    }
    if (ok) scored.push({ y, score });
  }
  scored.sort(
    (a, b) => b.score - a.score || `${a.y.brand}${a.y.line}`.localeCompare(`${b.y.brand}${b.y.line}`)
  );
  return scored.slice(0, limit).map((s) => s.y);
}

export const FIBER_CLASSES = [
  { id: 'wool', name: 'Wool', note: 'elastic · great stitch memory · ideal for colourwork' },
  { id: 'merino', name: 'Merino', note: 'fine · soft · even gauge' },
  { id: 'alpaca', name: 'Alpaca', note: 'warm · drapey · low elasticity (grows)' },
  { id: 'cashmere', name: 'Cashmere', note: 'luxe · soft · slight halo' },
  { id: 'mohair', name: 'Mohair', note: 'haloed · airy · softens chart detail' },
  { id: 'cotton', name: 'Cotton', note: 'crisp · inelastic · sharp definition' },
  { id: 'linen', name: 'Linen', note: 'structured · inelastic · drapes once worn' },
  { id: 'bamboo', name: 'Bamboo', note: 'silky · drapey · grows' },
  { id: 'silk', name: 'Silk', note: 'lustrous · strong · no memory' },
  { id: 'acrylic', name: 'Acrylic', note: 'washable · sturdy · thrifty' },
  { id: 'nylon', name: 'Nylon', note: 'strength · abrasion-resistant · usually blended' },
  { id: 'blend', name: 'Blend', note: 'mixed fibres' },
] as const;
